import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Reveal from '../components/ui/Reveal';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT = `<div className="programmes-content">
  <p className="lead">At Cambridge International Sr. Sec. School, Bhadana, we offer a comprehensive and continuous educational journey from early childhood right up to the 12th standard (Senior Secondary). Our curriculum is designed to foster intellectual growth, character development, and future readiness at every stage.</p>
  
  <h3 className="text-xl font-bold mt-6 mb-2">Pre-Primary Programme (Foundational Years)</h3>
  <p>Our foundational programme focuses on nurturing young minds through play-based learning, sensory exploration, and interactive activities. We build a strong base for cognitive, emotional, and social development, ensuring that every child steps into the world of formal education with confidence and joy.</p>

  <h3 className="text-xl font-bold mt-6 mb-2">Primary & Middle School (Classes I to VIII)</h3>
  <p>During these critical years of growth, we emphasize a well-rounded academic curriculum balanced with co-curricular activities. Our students are encouraged to ask questions, explore diverse subjects, and develop critical thinking skills. We focus on conceptual clarity in Mathematics, Sciences, Languages, and Social Studies, preparing them for higher academic challenges.</p>

  <h3 className="text-xl font-bold mt-6 mb-2">Secondary School (Classes IX to X)</h3>
  <p>As students transition into secondary education, our focus shifts towards rigorous academic preparation combined with life-skills training. We follow a structured CBSE curriculum that empowers students to excel in board examinations while discovering their core strengths and interests.</p>

  <h3 className="text-xl font-bold mt-6 mb-2">Senior Secondary (Classes XI to XII)</h3>
  <p>As a fully affiliated Senior Secondary School (up to 12th standard), we offer specialized streams to cater to the diverse career aspirations of our students. Whether it is Science (Medical and Non-Medical), Commerce, or Humanities, our expert faculty provides in-depth subject knowledge, practical laboratory experiences, and career guidance. We prepare our students not just for board exams, but for competitive entrance examinations and higher education.</p>
  
  <p className="mt-4"><strong>Beyond the Classroom:</strong> Across all grades, our programmes are enriched with sports, arts, digital literacy, and leadership initiatives, ensuring that every student graduates as a capable, confident, and responsible global citizen.</p>
</div>`;

const OurProgrammesPage = () => {
  const pageData = usePage('our-programmes', { content: DEFAULT_CONTENT });

  const title = 'Our Programmes';

  return (
    <>
      <SEO title={title} description="Our Programmes at Cambridge International Sr. Sec. School, Bhadana." keywords="Our Programmes, Cambridge International Sr. Sec. School" />

      <section className="page-hero">
        {!pageData.loading && <img src={pageData.bannerImage || '${process.env.PUBLIC_URL}/images/page-banners/curricullam-infrastructure.jpg'} alt={title} className="page-hero-img" loading="eager" />}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner">

            </div>
          </div>
        </div>
      </section>

      <section className="content-page">
        <div className="container">
          <div className="card p-7 md:p-10 max-w-[1000px] mx-auto">
            <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default OurProgrammesPage;
